import { useRef } from 'react';

import { frontConfig } from '../config';
import { handleError } from '../utils/common-utils';

/**
 * Sanity check. The Apollo cache should be pre-filled with the query data, i.e. `loading` should be false at the first render.
 * @param queryLoading the `loading` variable returned by Apollo useQuery.
 */
export function useCheckSSR(queryLoading: boolean) {
  const firstRenderRef = useRef(true);
  if (firstRenderRef.current === true) {
    firstRenderRef.current = false;
    if (queryLoading) {
      const msg =
        'Bug: a query is loading at the first render. It is supposed to be pre-fetched during SSR.';
      if (frontConfig.IS_DEV) {
        // If throwing is too violent, you can replace it with a console.error.
        // And if running the check on server-side render (in addition to client) is too much, you can also wrap into a useEffect().
        handleError(msg);
        // throw new Error(msg);
      } else {
        // Not a bug when navigating from another page instead or refreshing the page. This case is not detected well here, so we shouldn't log anything in production.
        // console.warn(msg);
      }
    }
  }
}
